﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const germanLabels: TranslationLabels = {
  Actions: "Aktionen",
  Actions_Add: "Hinzufügen",
  Actions_Add_Board: "Hinzufügen",
  Actions_AddBoard: "Erstellen",
  Actions_AddMeeting: "Hinzufügen",
  Actions_AddMeeting_Submitting: "Erstelle Sitzung …",
  Actions_Back: "Zurück",
  Actions_Browse: "Durchsuchen …",
  Actions_Cancel: "Abbrechen",
  Actions_Close: "Schliessen",
  Actions_Close_AriaLabel: "Schliessen",
  Actions_Copy_AgendaItem: "Kopieren",
  Actions_Delete: "Löschen",
  Actions_Delete_AgendaItem: "Löschen",
  Actions_Delete_AgendaItem_Confirm: "Willst du dieses Traktandum wirklich löschen?",
  Actions_Delete_AgendaItem_Pending: "Traktandum wird gelöscht …",
  Actions_Delete_Document: "Dokument löschen",
  Actions_Delete_Document_Confirm: "Willst du dieses Dokument löschen?",
  Actions_Delete_Document_Pending: "Dokument wird gelöscht …",
  Actions_Delete_Meeting: "Löschen",
  Actions_Delete_Meeting_Confirm: "Willst du diese Sitzung inklusive aller Traktanden, Teilnehmer*innen und Pendenzen wirklich löschen?",
  Actions_Delete_Meeting_Pending: "Die Sitzung inklusive aller Traktanden, Teilnehmer*innen und Pendenzen wird gelöscht …",
  Actions_Delete_Participant: "Löschen",
  Actions_Delete_Participant_Confirm: "Willst du diese Teilnehmer*in wirklich löschen?",
  Actions_Delete_Participant_Pending: "Teilnehmer*in wird gelöscht …",
  Actions_Delete_Task_Confirm: "Willst du diese Pendenz wirklich löschen?",
  Actions_Delete_Task_Pending: "Pendenz wird gelöscht …",
  Actions_Delete_Task_Title: "Pendenz löschen",
  Actions_DocumentsGrid_Tooltip: "Aktion für die Synchronisierung",
  Actions_Download: "Herunterladen",
  Actions_Edit: "Bearbeiten",
  Actions_Edit_AgendaItem: "Traktandum bearbeiten",
  Actions_Edit_Meeting: "Sitzung bearbeiten",
  Actions_Edit_Participant: "Teilnehmer*in bearbeiten",
  Actions_Edit_Task: "Pendenz bearbeiten",
  Actions_EditSettings: "Einstellungen bearbeiten",
  Actions_GoToBoard: "Gremium Einstellungen öffnen",
  Actions_GoToMeetings: "Gremium Sitzungen öffnen",
  Actions_Help: "Hilfe",
  Actions_HideChildren: "Untergeordnete Elemente ausblenden",
  Actions_HideDiff: "Unterschiede ausblenden",
  Actions_Indent_AgendaItem: "Einzug vergrössern",
  Actions_Move_AgendaItem: "Verschieben",
  Actions_No: "Nein",
  Actions_None: "Keine",
  Actions_OneDriveMeetingFolder: "Sitzungs-Ordner auf OneDrive öffnen (erst nach durchgeführtem Sync verfügbar).",
  Actions_OneDriveSync: "Synchronisieren",
  Actions_OneDriveSync_Delete: "Löschen",
  Actions_OneDriveSync_Failure: "Die Synchronisierung mit OneDrive konnte nicht durchgeführt werden, bitte versuche es nochmals.",
  Actions_OneDriveSync_Success: "Die Synchronisierung mit OneDrive wurde erfolgreich durchgeführt.",
  Actions_OneDriveSyncFolder: "Ordner öffnen",
  Actions_Open: "Öffnen",
  Actions_OpenPhonebook: "Telefonbuch öffnen",
  Actions_OpenUserProfile: "Benutzerprofil öffnen",
  Actions_Outdent_AgendaItem: "Einzug verkleinern",
  Actions_Overwrite: "Überschreiben",
  Actions_Participant_Edit: "Teilnehmer*in bearbeiten",
  Actions_Refresh: "Neu Laden",
  Actions_Reset: "Zurücksetzen",
  Actions_Retry: "Nochmals versuchen",
  Actions_Save: "Speichern",
  Actions_SendTo_AgendaItem: "Senden an",
  Actions_ShowChildren: "Untergeordnete Elemente anzeigen",
  Actions_ShowDiff: "Unterschiede anzeigen",
  Actions_Submit: "Speichern",
  Actions_Synchronize: "Synchronisieren",
  Actions_ToggleDetails: "Details ein/ausblenden",
  Actions_View: "Details",
  Actions_View_AgendaItems: "Traktanden öffnen",
  Actions_View_Documents: "Dokumente öffnen",
  Actions_View_History: "Versionsverlauf",
  Actions_View_Meeting: "Sitzung öffnen",
  Actions_View_OneDriveSync: "OneDrive Synchronisation öffnen",
  Actions_View_Participants: "Teilnehmer*in öffnen",
  Actions_View_Tasks: "Pendenzen öffnen",
  Actions_Yes: "Ja",
  AddAgendaItemPosition: "Einfügen an",
  AddAgendaItemPosition_AfterSelected: "Nach gewähltem",
  AddAgendaItemPosition_ContextHelp: "Wähle, wo das neue Traktandum eingefügt werden soll. «Am Ende» hängt es ans Ende der Sitzung. «Nach gewähltem» platziert es direkt nach dem aktuell gewählten Traktandum. Ist kein Traktandum ausgewählt, wird es ebenfalls am Ende eingefügt.",
  AddAgendaItemPosition_Last: "Am Ende",
  AddBoard_Label: "Gremium hinzufügen",
  AddBoardPanel_Header: "Gremium hinzufügen",
  Added: "Hinzugefügt",
  AddGroupMember: "Mitglied hinzufügen",
  AddMeeting_Description: "Bitte hier den Titel der Sitzung definieren (Details können nachfolgend angepasst werden). Bitte folgendes Format verwenden: JJJJ-MM-TT_Kürzel Gremium-Sitzung (Beispiel: 2019-08-12_KL-Sitzung).",
  AddMeeting_Title: "Sitzung hinzufügen",
  AddParticipant_Description: "Alle im Gremium berechtigten Personen können als Teilnehmer*innen zu Sitzungen hinzugefügt werden.",
  AddParticipant_NoDataTemplate: "Teilnehmer*in nicht gefunden. Zusätzliche Teilnehmer*innen können in den Gremium Einstellungen hinzugefügt werden.",
  AddParticipant_Placeholder: "Teilnehmer*in hinzufügen …",
  AddParticipant_Title: "Teilnehmer*in hinzufügen",
  AddUser: "Hinzufügen",
  AddUser_Label: "User hinzufügen",
  Admin: "Admin",
  AdminBoardsFilter_Placeholder: "Suche nach Gremien …",
  AdminUsersFilter_Placeholder: "User suchen …",
  AgendaItem: "Traktandum",
  AgendaItem_Add_Submitting: "Erstelle Traktandum …",
  AgendaItem_AdditionalInfo_Description: "-",
  AgendaItem_AdditionalInfo_Title: "Zusatztext",
  AgendaItem_Confidential_Active_Tooltip: "Das Traktandum ist streng vertraulich. Arbeitsdokumente werden ausserhalb der Sitzungverwaltung verwaltet, und das Protokoll (streng vertraulich) wird separat verteilt.",
  AgendaItem_Confidential_Description: "Bitte hier vermerken, wenn das Traktandum streng vertraulich ist. Die Abgabe der Unterlage erfolgt in diesem Fall zwingend per E-Mail und die Protokollierung erfolgt in einem separaten, streng vertraulichen Protokoll.",
  AgendaItem_Confidential_Inactive_Tooltip: "Das Traktandum ist vertraulich.",
  AgendaItem_Confidential_Title: "Streng vertraulich",
  AgendaItem_Confidential_Tooltip: "Streng Vertraulich",
  AgendaItem_Decision_Description: "Bitte hier das konkrete Antragsdispositiv zum Beschluss angeben (aus der Vorlage zu überführen).",
  AgendaItem_Decision_Title: "Beschluss",
  AgendaItem_Department_Description: "Bitte hier das Kürzel der für das Traktandum verantwortlichen Einheit aufführen. Im Grundsatz immer -1 bis -2 Hierarchieebenen. Bspw. \"F\", \"K-UE\", \"G\".",
  AgendaItem_Department_Title: "Verantwortliche Einheit (Kürzel)",
  AgendaItem_Department_Tooltip: "Verantwortliche Einheit",
  AgendaItem_DocumentStatus_Description: "Zeigt die Anzahl Dokumente welche dem Traktandum zugeordnet sind",
  AgendaItem_DocumentStatus_Title: "Arbeitsdokumente",
  AgendaItem_DocumentStatus_Tooltip: "Dokumente",
  AgendaItem_Duration_Description: "Bitte hier die geplante Dauer des Traktandums in Minuten angeben. Immer so wenig Zeit wie vereinbart/zwingend nötig angeben.",
  AgendaItem_Duration_Title: "Dauer [min.]",
  AgendaItem_Duration_Tooltip: "Zeitbedarf",
  AgendaItem_EdecideType_Description: "Der eDecide Vorlagentyp wird für die Erstellung eines eDecide Laufs verwendet. Der Standardwert ist leer. Es werden nur die Traktanden an eDecide übermittelt, welche einen Vorlagentyp != leer enthalten.",
  AgendaItem_EdecideType_Title: "eDecide-Vorlagentyp",
  AgendaItem_EdecideType_Tooltip: "eDecide Typ",
  AgendaItem_Edit: "Bearbeiten",
  AgendaItem_EndTime_Description: "Das Feld wird aufgrund der Startzeit der Sitzung und der Dauer der Traktanden automatisch berechnet.",
  AgendaItem_EndTime_Title: "Endzeit",
  AgendaItem_FinalBoard_Description: "Bitte in diesem Feld das Endgremium (Kürzel) mit dem Vorlagen-Typ (BV, IV, Andere) nennen. Beispiel: KL-BV, VR-IV, GLP-Workshop.",
  AgendaItem_FinalBoard_Title: "Endgremium / Vorlagen-Typ",
  AgendaItem_FinalBoard_Tooltip: "Endgremium / Vorlagen-Typ",
  AgendaItem_FinalBoardDate_Title: "Endgremium Datum",
  AgendaItem_Guests_Description: "Bitte hier die Gäste zum Traktandum erfassen. Mehrere Werte können mit Semikolon <code>;</code> oder einer neuen Zeile getrennt werden.",
  AgendaItem_Guests_Title: "Gäste",
  AgendaItem_HeadingNumber_Description: "-",
  AgendaItem_HeadingNumber_Title: "Nr.",
  AgendaItem_Level_Description: "Internes Feld, wird nicht dargestellt",
  AgendaItem_Level_Title: "Einrückung",
  AgendaItem_Locked_Active_Tooltip: "Das Traktandum ist für Mitglieder zur Bearbeitung gesperrt.",
  AgendaItem_Locked_Description: "Bitte hier das Traktandum sperren, wenn ausser den Besitzern des Gremiums niemand mehr etwas anpassen soll.",
  AgendaItem_Locked_Inactive_Tooltip: "Das Traktandum ist für Mitglieder zur Bearbeitung freigegeben.",
  AgendaItem_Locked_Title: "Gesperrt",
  AgendaItem_Locked_Tooltip: "Gesperrt für Bearbeitung durch Mitglieder",
  AgendaItem_Meeting_ContextHelp_Title: "Sitzung",
  AgendaItem_NavBar_AddAgendaItem: "Hinzufügen",
  AgendaItem_NavBar_MeetingIsTemplate: "Die Sitzung ist eine Standard-Sitzung (aka Vorlage) und ist für die Bearbeitung durch Mitglieder gesperrt.",
  AgendaItem_NavBar_MeetingLocked: "Die Sitzung ist für die Bearbeitung durch Mitglieder gesperrt.",
  AgendaItem_NavBar_SubmittedAgendaItems: "Eingereichte Traktanden",
  AgendaItem_NavBar_ToggleNav: "Navigation ein/ausblenden",
  AgendaItem_NavBar_ToggleView: "Ansichten wählen",
  AgendaItem_NavBar_View: "Ansicht",
  AgendaItem_New_Placeholder: "Neues Traktandum …",
  AgendaItem_Note_Description: "Bitte hier zusätzliche Informationen zum Traktandum erfassen.",
  AgendaItem_Note_Title: "Bemerkungen",
  AgendaItem_Perusal_Description: "Bitte hier das konkrete Antragsdispositiv zur Kenntnisnahme angeben (aus der Vorlage zu überführen).",
  AgendaItem_Perusal_Title: "Kenntnisnahme",
  AgendaItem_Position_Description: "Internes Feld, wird nicht dargestellt",
  AgendaItem_Position_Title: "Position",
  AgendaItem_ProtocolEntry_Description: "Antragstext aus der Wordvorlage, mit welcher Bereiche Traktanden in die Sitzung einreichen. ev. = Beschluss. Erfassung geschieht durch Bereiche",
  AgendaItem_ProtocolEntry_Title: "Protokoll-Eintrag",
  AgendaItem_ProtocolEntryDraft_Description: "Protokolleintrag welcher nicht auf dem iPAD dargestellt wird.",
  AgendaItem_ProtocolEntryDraft_Title: "Protokoll-Eintrag (Entwurf)",
  AgendaItem_Sortable: "-",
  AgendaItem_Sortable_Tooltip: "Die Traktanden können mit Drag & Drop sortiert werden.",
  AgendaItem_Speakers_Title: "Gäste (Protokoll)",
  AgendaItem_StandardVersion_Title: "StandardVersion",
  AgendaItem_StartTime: "-",
  AgendaItem_StartTime_Title: "Startzeit",
  AgendaItem_StartTime_Tooltip: "Startzeit",
  AgendaItem_Status: "Status",
  AgendaItem_Status_Description: "Status des Traktandums. Rein informativ.",
  AgendaItem_Status_Title: "Status",
  AgendaItem_Title_Description: "Internes Feld - Wird aus Beschreibung berechnet und auf maximal 255 Zeichen gekürzt",
  AgendaItem_Title_Title: "Titel",
  AgendaItem_Type_Description: "Bitte Typ erfassen.",
  AgendaItem_Type_Title: "Typ",
  AgendaItems: "Traktanden",
  AgendaItems_Description: "Enthält die Traktanden des Gremiums",
  AgendaItems_Loading: "Lade Traktanden …",
  AgendaItems_Loading_EditForm: "Lade Traktandum Formular …",
  AgendaItems_Title: "Traktanden",
  AgendaItemsDetail_Empty: "Bitte wähle ein Traktandum aus",
  AgendaItemsList_Empty: "Es wurden keine Traktanden erfasst",
  AgendaItemStatus_Approved: "Freigegeben",
  AgendaItemStatus_Archived: "Archiviert",
  AgendaItemStatus_Default: "In Bearbeitung",
  AgendaItemStatus_Deleted: "Gelöscht",
  AgendaItemStatus_Finalized: "Abgeschlossen",
  AgendaItemStatus_Itemized: "Traktandiert",
  AgendaItemStatus_Published: "Publiziert",
  AgendaItemStatus_Unknown: "Unbekannt",
  AgendaItemType_Break: "Pause",
  AgendaItemType_Category: "Kategorie",
  AgendaItemType_Decision: "BV",
  AgendaItemType_Decision_eDecide: "BV - eDecide",
  AgendaItemType_Decision_Tooltip: "Beschluss-Vorlage",
  AgendaItemType_Discussion: "Diskussion",
  AgendaItemType_Empty: "Leer",
  AgendaItemType_Information: "IV",
  AgendaItemType_Information_eDecide: "IV - eDecide",
  AgendaItemType_Information_Tooltip: "Informations-Vorlage",
  AgendaItemType_NoDataTemplate: "Kein Typ gefunden",
  AgendaItemType_Other: "Andere",
  AgendaItemType_Placeholder: "Wähle Typ …",
  All: "Alle",
  ApplicationName: "SiVe",
  AuditLog: "Versionsverlauf",
  AuditLog_Action: "Aktion",
  AuditLog_Add: "Hinzugefügt",
  AuditLog_After: "Nachher",
  AuditLog_Before: "Vorher",
  AuditLog_Changes: "Änderungen",
  AuditLog_Created: "Geändert am",
  AuditLog_CreatedBy: "Geändert von",
  AuditLog_Date: "Am",
  AuditLog_Diff: "Unterschiede",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Felder",
  AuditLog_Property: "Feld",
  AuditLog_Remove: "Gelöscht",
  AuditLog_State: "Aktion",
  AuditLog_Update: "Geändert",
  AuditLog_User: "Von",
  AuditLogs: "Versionsverläufe",
  Auth_Loading: "Lade Applikation …",
  Auth_LoginFailed: "Anmeldung fehlgeschlagen.",
  Auth_Redirecting: "Lade Anmeldung …",
  Auth_TryAgain: "Versuche es nochmals.",
  Back: "Zurück",
  BackHome: "Zurück zur Startseite",
  BaseData: "Stammdaten",
  BlobDocument: "Dokument",
  Board: "Gremium",
  Board_ArchivedDate: "Archivierungsdatum",
  Board_BoardUniqueId: "eDecide Gremium Id",
  Board_BoardUniqueId_Help: "Die eDecide Gremium Id wird verwendet, um Läufe aus dem aktuellen Gremium nach eDecide zu senden. Diese ID kann in eDecide im Screen Gremium verwalten kopiert werden. Die Funktion Senden an ist nur aktiv falls hier eine ID eingetragen wurde.",
  Board_BusinessOwner: "Zuständige Person",
  Board_BusinessOwner_Help: "Die Person die fachlich für dieses Gremium verantwortlich ist, hat ursprünglich das Gremium bestellt, oder es von einer vorherigen Verantwortlichen Person übernommen.",
  Board_ClearCache: "Cache des Gremiums leeren",
  Board_DefaultDuration: "Standarddauer",
  Board_DefaultDuration_Help: "Die Standarddauer wird bei jeder neu erstellten Sitzung zur Startzeit hinzugerechnet und ergibt die geplante Endzeit.",
  Board_DefaultLocation: "Ort/Sitzungszimmer",
  Board_DefaultLocation_Help: "Dieser Text wird bei jeder neu erstellten Sitzung als Ort/Sitzungszimmer eingetragen.",
  Board_DefaultRemarks: "Bemerkungen",
  Board_DefaultRemarks_Help: "Dieser Text wird bei jeder neu erstellten Sitzung als Bemerkung eingetragen.",
  Board_DefaultTime: "Startzeit hh:mm",
  Board_DefaultTime_Help: "Die Uhrzeit wird bei jeder neu erstellten Sitzung als vorgeschlagene Startzeit eingesetzt.",
  Board_Description: "Beschreibung",
  Board_Description_Help: "-",
  Board_DownloadConfig: "Konfiguration herunterladen",
  Board_DownloadConfig_Tooltip: "Lade die Konfigurationsliste als Zip-Datei herunter",
  Board_DownloadUsers: "Liste der Gremium-Mitglieder herunterladen",
  Board_DownloadUsers_Tooltip: "Die Benutzerliste als CSV-Datei herunterladen",
  Board_EdecideId: "eDecide Gremium Id",
  Board_EdecideId_Help: "Die eDecide Gremium Id wird verwendet, um Läufe aus dem aktuellen Gremium nach eDecide zu senden. Diese ID kann in eDecide im Screen Gremium verwalten kopiert werden. Die Funktion Senden an ist nur aktiv falls hier eine ID eingetragen wurde.",
  Board_Id: "Id",
  Board_Id_Help: "Der Datenbank-Schlüssel des Gremiums",
  Board_LongName: "Langname",
  Board_LongName_Help: "Der Langname wird in den Dokument-Vorlagen und im Benutzerinterface der Sitzungsverwaltung verwendet. Übliche Werte sind der volle Name des Gremiums wie Verwaltungsrat oder  Konzernleitung.",
  Board_Name: "Interner Name",
  Board_Name_Help: "Der interne Name wird als eindeutiger Name des Gremiums in der Browseradresszeile verwendet (URL). Wenn ein interner Name geändert wird, bleiben die vorherigen internen Namen dem Gremium zugeordnet, und bleiben im System erhalten.",
  Board_NameHistories_Title: "Vorherige Namen",
  Board_OrganisationUnit: "Organisationseinheit",
  Board_OrganisationUnit_Help: "Die Organisationseinheit die fachlich für dieses Gremium verantwortlich ist, entspricht in der Regel der verantwortlichen Person.",
  Board_Settings: "Gremium-Einstellungen",
  Board_ShortName: "Kurzname",
  Board_ShortName_Help: "Der Gremium Kurzname wird in den Dokument-Vorlagen und im Benutzerinterface der Sitzungsverwaltung verwendet. Übliche Werte sind eine Abkürzung des Gremiums wie VR (Verwaltungsrat) oder KL (Konzernleitung)",
  Board_SignatureFirstName: "Unterschrift Vorname",
  Board_SignatureFirstName_Help: "Der Signatur-Vorname kann bei der Generierung der E-Mails, Protokolle und Einladungen eingefügt werden.",
  Board_SignatureLastName: "Unterschrift Nachname",
  Board_SignatureLastName_Help: "Der Signatur-Nachname kann bei der Generierung der E-Mails, Protokolle und Einladungen eingefügt werden.",
  Board_Status: "Status",
  Board_Status_Help: "Der Status des Gremiums bildet den Lebenszyklus in SiVe ab. Gelöschte Gremien werden nicht mehr im Dashboard angezeigt.",
  Board_Update_Error: "Gremium konnte nicht gespeichert werden: {0}",
  Board_Update_Success: "Gremium wurde gespeichert",
  BoardMemberships: "Berechtigungen",
  BoardPicker_Placeholder: "Gremiem Suchbegriff eingeben …",
  Boards: "Gremien",
  BoardSettings: "Gremium-Einstellungen",
  BoardSettings_MeetingDefaults: "Standardwerte für Sitzungen",
  BoardSettings_StandardMeetingOldOnly: "Die folgenden Einstellungen werden nur bei Anwendung der Standard-Sitzung «{0}» verwendet.",
  BoardStatus_Active: "Aktiv",
  BoardStatus_Archived: "Archiviert",
  BoardStatus_Deleted: "Gelöscht",
  BoardStatus_Draft: "Entwurf",
  BoardStatus_Unknown: "Unbekannt",
  BoardTemplate_Delete_Error: "Vorlage konnte nicht gelöscht werden: {0}",
  BoardTemplate_Delete_Success: "Vorlage wurde gelöscht",
  BoardTemplate_Upload_Error: "Vorlage konnte nicht hochgeladen werden: {0}",
  BoardTemplate_Upload_Success: "Vorlage wurde erfolgreich hochgeladen",
  BoardTemplate_UploadTitle: "Vorlage hochladen",
  BoardTemplates_Description: "Diese Vorlagen wurden für das aktuelle Gremium angepasst. Wende dich an egpl@sbb.ch, wenn du Hilfe bei der Konfiguration benötigst.",
  BoardTemplates_Title: "Gremium-Vorlagen",
  BoardUnique: "Eindeutige ID",
  BusinessOwner: "Besitzer*in",
  ButtonHelp: "Hilfe",
  By: "von",
  ClaimIssuer: "Aussteller von Ansprüchen",
  Claims: "Benutzeransprüche",
  ClaimType: "Anspruchsart",
  Confirm_Accept: "JA",
  Confirm_Cancel: "Abbrechen",
  Confirm_Content: "Es wurden ungespeicherte Änderungen erkannt. Willst du die Änderungen wirklich verwerfen?",
  Confirm_Discard: "Änderungen verwerfen",
  Confirm_Title: "Ungespeicherte Änderungen",
  ContextHelp: "Hilfe",
  ContextHelp_Fallback_Content: "Zum Thema {0} wurde keine Kontext-Hilfe erfasst.",
  ContextHelp_Fallback_Title: "Hilfe",
  ContextHelp_TemplateId_Description: "Die Attribute der gewählten Standardsitzung (Sitzung, Traktanden, Teilnehmer) werden bei der Erstellung der neuen Sitzung übernommen.",
  ContextHelp_TemplateId_Title: "Standardsitzung wählen",
  CopyToClipboard: "In Zwischenablage kopieren",
  CopyToClipboard_Idle: "In Zwischenablage kopieren…",
  CopyToClipboard_Success: "Kopiert!",
  Created: "Erstellt",
  Dashboard_Button_OwnerExport: "ungefilterte Liste herunterladen",
  Dashboard_Button_UserExport: "gefilterte Liste herunterladen",
  Dashboard_EmptyTable: "Es wurden keine Sitzungen gefunden, die Deinen Kriterien entsprechen.",
  Dashboard_Filter_Tasks: "Nur meine Pendenzen",
  Dashboard_Grid_Header_EndDate: "Abgabedatum",
  Dashboard_Grid_Header_Meeting: "Sitzung",
  Dashboard_Grid_Header_StartDate: "Startdatum",
  Dashboard_Loading: "Lade Sitzungen …",
  Dashboard_Meeting_PlannedEndTime: "Geplante Endzeit",
  Dashboard_Meeting_ProjectedEndTime: "Effektive Endzeit",
  Dashboard_Meeting_Tooltip: "Anzahl Sitzungen ab dem gewählten Datum",
  Dashboard_Navbar_DetailedDashboard: "Detail-Dashboard öffnen",
  Dashboard_Navbar_Edecide: "eDecide öffnen",
  Dashboard_Toggle_MyCommittees: "Meine Gremien",
  Dashboard_Toggle_Tasks: "Pendenzen anzeigen",
  Date_Unknown: "unbekannt",
  DateFilterBar_Dashboard_Description: "Im Dashboard werden die kommenden Sitzungen aller Gremien angezeigt, in denen du berechtigt bist. Mit dem Datumsfilter kann der Anzeigezeitraum (Grundeinstellung: heute -14 Tage) geändert werden. Alle angezeigten Gremien und Sitzungen können per Klick aufgerufen werden.",
  DateFilterBar_Dashboard_Title: "Datumsfilter",
  DateFilterBar_Meetings_Description: "Mit dem Datumsfilter kann der Anzeigezeitraum (Grundeinstellung: heute -14 Tage) geändert werden.",
  DateFilterBar_Meetings_Title: "Datumsfilter",
  DateFilterBar_ShowMeetings: "Zeige Sitzungen ab",
  DefaultDuration: "Dauer",
  DefaultLocation: "Ort",
  DefaultRemarks: "Bemerkungen",
  DefaultTemplates_Description: "Die Standard-Konfiguration der Applikation wird vom SiVe Entwicklungsteam mit der Applikation installiert. Korrekturen von Vorlagen werden so automatisch für alle Gremien aktualisiert.",
  DefaultTemplates_Title: "Vorlagen",
  DefaultTime: "Startzeit",
  Deleted: "Gelöscht",
  DeputyMember: "Stellvertreter Mitglieder",
  DeputyVisitor: "Stellvertreter Besucher",
  Description: "Beschreibung",
  DismissableDialog_Close_Label: "Schlissen",
  DismissableDialog_Close_Tooltip: "Meldung nicht mehr anzeigen",
  Document_Action_Title: "Aktion",
  Document_Add_Uploading: "Dokument wird hochgeladen …",
  Document_Confidential_Title: "Streng vertraulich",
  Document_FileSize_Title: "Grösse",
  Document_Modified_Title: "Geändert",
  Document_Modified_Tooltip: "Änderungsdatum des Traktandums oder der Datei",
  Document_Title_Title: "Titel",
  Document_Title_Tooltip: "Name des Traktandums oder der Datei",
  Documents_Loading: "Lade Dokumente …",
  Documents_NavBar_Refresh: "Aktualisieren",
  Documents_NavBar_Sync_Description: "Wähle in der Spalte Aktion für Traktanden oder einzelne Dokumente eine Aktion, und führe diese mit dem Button Synchronisieren durch",
  Documents_NavBar_Sync_Submitting: "Synchronisiere Dateien …",
  Documents_NavBar_Sync_Title: "Hilfe zur Synchronisierung",
  Documents_NavBar_ToggleNav: "Navigation ein/ausblenden",
  Documents_NavBar_View: "Ansicht",
  Documents_Refreshing: "Aktualisiere Dokumente …",
  Documents_Secret: "Zusätzliche Dokumente",
  DocumentsForm_None: "Keine",
  DocumentsList_Empty: "Es wurden keine Traktanden erfasst.",
  DocumentsPanel_Description: "Die folgenden Dateien wurden zu diesem Traktandum hochgeladen",
  DocumentsPanel_Header: "Dokumente",
  DocumentsPanel_Loading: "Lade Dokumente …",
  DocumentStatus_Default: "Aktiv",
  DocumentStatus_Deleted: "Gelöscht",
  Edecide: "eDecide",
  Edecide_NoBoardLinked: "Aktuell ist kein eDecide Gremium mit dieser Instanz verknüpft.",
  Edecide_RunManagementUrl: "Lauf bearbeiten",
  Edecide_RunUrl: "Lauf Details",
  EdecidePanel_CreateRun_Failure: "Lauf konnte nicht erstellt werden.",
  EdecidePanel_CreateRun_Failure_NotFound: "Das eDecide Gremium existiert nicht. Bitte überprüfe die eDecide Gremium Id in den Einstellungen.",
  EdecidePanel_CreateRun_Success: "Lauf erstellt",
  EdecidePanel_DuplicateRuns: "Existierende Läufe gefunden",
  EdecidePanel_DuplicateRuns_Text: "Mindestens ein eDecide Lauf existiert mit dieser externen ID. Falls die Daten aus Sive erneut übertragen werden sollen, müssten die Duplikate zuerst gelöscht werden.",
  EdecidePanel_Header: "eDecide Lauf",
  EdecidePanel_Loading: "Lade Vorschau …",
  EdecidePanel_OverrideTitle: "Titel",
  EdecidePanel_OverrideTitle_HelpContent: "Der Titel des zu erstellenen des Laufs in eDecide kann in diesem Feld übersteuert werden. Dies sollte nur in Ausnahmefällen notwendig sein. Die Überprüfung von Duplikaten wird nicht über den Titel, sondern über die Externe ID vorgenommen.",
  EdecidePanel_OverrideTitle_HelpTitle: "Lauf Titel übersteuern",
  EdecidePanel_Participant_Name: "Name",
  EdecidePanel_Participants: "Teilnehmer*innen",
  EdecidePanel_Submit: "Erstelle Lauf",
  EdecidePanel_Submitting: "Erstelle Lauf in eDecide …",
  EdecidePanel_Topic_Title: "Titel",
  EdecidePanel_Topic_Type: "Typ",
  EdecidePanel_Topics: "Traktanden (Geschäfte)",
  EdecidePanel_UniqueId: "Externe ID",
  EdecideStatus_CompleteRunFailure: "Lauf konnte nicht abgeschlossen werden.",
  EdecideStatus_CompleteRunSuccess: "Lauf wurde erfolgreich abgeschlossen.",
  EdecideStatus_CompletingRun: "Lauf wird abgeschlossen …",
  EdecideStatus_CreateRunFailure: "Lauf konnte nicht erstellt werden.",
  EdecideStatus_CreateRunSuccess: "Lauf wurde erfolgreich erstellt",
  EdecideStatus_CreatingRun: "Lauf wird erstellt …",
  EdecideStatus_Empty: "Es wurde noch kein Lauf gestartet.",
  EdecideType_Decision: "Beschluss",
  EdecideType_Decision_Tooltip: "Dieses Traktandum wird als Beschluss an eDecide übermittelt",
  EdecideType_Default: "-",
  EdecideType_Information: "Information",
  EdecideType_Information_Tooltip: "Dieses Traktandum wird als Information an eDecide übermittelt",
  EditAgendaItemPanel_Header: "Traktandum bearbeiten",
  EditBoardPanel_Header: "Gremium bearbeiten",
  EditMeetingPanel_Header: "Sitzung bearbeiten",
  EditParticipantPanel_Header: "Teilnehmer*in  bearbeiten",
  EditTaskPanel_Header: "Pendenz bearbeiten",
  Email: "Email",
  EmptyTable: "Keine Daten in der Tabelle vorhanden",
  Entity: "Entität",
  Entity_Add_Failure: "{EntityName} konnte nicht erstellt werden.",
  Entity_Add_Success: "{EntityName} erfolgreich erstellt.",
  Entity_Delete_ConfirmContent: "Willst du {EntityName} wirklich löschen?",
  Entity_Delete_ConfirmTitle: "Löschen bestätigen",
  Entity_Delete_Failure: "{EntityName} konnte nicht gelöscht werden.",
  Entity_Delete_Success: "{EntityName} erfolgreich gelöscht.",
  Entity_IsDeleted_Description: "Dieser Datensatz ist gelöscht (Status: Gelöscht). Der Datensatz kann i.d.R. reaktiviert werden, indem ein anderer Status als gelöscht gesetzt wird.",
  Entity_IsDeleted_Title: "Ist gelöscht",
  Entity_Patch_Failure: "Deine Anfrage konnte nicht verarbeitet werden, bitte versuche es nochmals.",
  Entity_Patch_SuccessNoChanges: "Deine Anfrage wurde verarbeitet, es wurden aber keine Änderungen erkannt.",
  Entity_Patch_Unauthorized: "Du bist nicht berechtigt, diese Anpassung durchzuführen.",
  Entity_Refresh_Failure: "{EntityName} konnte nicht neugeladen werden.",
  Entity_Refresh_Success: "{EntityName} erfolgreich neugeladen.",
  Entity_Save_Failure: "{EntityName} konnte nicht gespeichert werden.",
  Entity_Save_Success: "{EntityName} erfolgreich gepeichert.",
  Entity_Update_Failure: "{EntityName} konnte nicht aktualisiert werden.",
  Entity_Update_Success: "{EntityName} erfolgreich aktualisiert.",
  EntityCount: "# Einträge",
  EntityTitle_Unknown: "Unbekannt",
  Error_FailedToAddUser: "Benutzer '{0}' konnte nicht hinzugefügt werden.",
  ErrorCodes_BadRequest: "Bei der Abfrage ist etwas fehlgeschlagen. Es handelt sich um einen Client-Fehler (zum Beispiel: fehlerhafte Anfragesyntax, ungültiges Framing der Anfragemeldung oder irreführendes Anfrage-Routing).",
  ErrorCodes_InternalServerError: "Bei der Bearbeitung Deiner Anfrage ist ein Fehler aufgetreten.",
  ErrorCodes_NoResponse: "Der Backend Dienst ist nicht erreichbar.",
  ErrorCodes_NotFound: "Die Ressource wurde nicht gefunden.",
  ErrorCodes_Unauthorized: "Du hast keine Berechtigungen für den Zugriff auf die Ressource.",
  ErrorDialog_AppInsights: "Mit den folgenden Eigenschaften kann der aufgetretene Fehler auf den App Insights im Azure Portal analysiert werden (Investigate > Search > Filter). Bitte füge diese Eigenschaften bei der Erstellung des Incident hinzu.",
  ErrorDialog_AppInsights_Date: "Zeitpunkt",
  ErrorDialog_AppInsights_OperationId: "Operation",
  ErrorDialog_AppInsights_SessionId: "Sitzung",
  ErrorDialog_AppInsights_UserId: "Benutzer",
  ErrorDialog_AuthFailure_Text: "Beim Ausführen der Anfrage ist ein Authentisierungs-Fehler aufgetreten. Bitte lade die Seite neu und versuche es noch mal.",
  ErrorDialog_AuthFailure_Title: "Authentisierungsfehler",
  ErrorDialog_ComponentFailure_Text: "Es ist ein Fehler im Benutzerinterface aufgetreten. Bitte prüfe die Fehlermeldung in der Browser Konsole (F12)",
  ErrorDialog_ComponentFailure_Title: "UI Fehler",
  ErrorDialog_ForbiddenFailure_Text: "Du hast keine Berechtigung, diesen Vorgang auszuführen oder auf diese Ressource zuzugreifen.",
  ErrorDialog_ForbiddenFailure_Title: "Zugriff verweigert",
  ErrorDialog_NotFoundFailure_Text: "Der Datensatz wurde nicht gefunden. Möglicherweise wurde er in der Zwischenzeit von einem anderen Benutzer gelöscht, oder es wurde eine ungültige Kombination von Parametern verwendet. Bitte versuche es nochmals.",
  ErrorDialog_NotFoundFailure_Title: "Nicht gefunden",
  ErrorDialog_OneDrive_Text: "Es ist ein allgemeiner OneDrive Fehler aufgetreten. Bitte kontaktiere den IT Support.",
  ErrorDialog_OneDrive_Title: "OneDrive Fehler",
  ErrorDialog_OneDriveMissingSource_Title: "OneDrive Fehler",
  ErrorDialog_OneDriveNotFound_Text: "OneDrive steht in Deinem Konto nicht zur Verfügung. Bitte kontaktiere den IT Support.",
  ErrorDialog_OneDriveNotFound_Title: "OneDrive Fehler",
  ErrorDialog_OneDrivePermissionsDenied_Text: "Du bist nicht Teilnehmer*in dieser Sitzung, daher steht dir die Funktion nicht zur Verfügung.",
  ErrorDialog_OneDrivePermissionsDenied_Title: "Keine Berechtigung für OneDrive Sync",
  ErrorDialog_ServerFailure_Text: "Beim Ausführen der Anfrage ist ein Server Fehler aufgetreten. Bitte lade die Seite neu und versuche es noch mal.",
  ErrorDialog_ServerFailure_Title: "Server Fehler",
  ErrorDialog_UnknownFailure_Text: "Beim Ausführen der Anfrage ist ein Unbekannter Fehler aufgetreten. Bitte lade die Seite neu und versuche es noch mal.",
  ErrorDialog_UnknownFailure_Title: "Unbekannter Fehler",
  Exception: "Ausnahme",
  Exists: "Existiert",
  Extended_Mode: "Erweiterter Modus",
  File: "Datei",
  FileAction_Delete: "Wird gelöscht",
  FileAction_Existing: "Bestehend",
  FileAction_New: "Wird hochgeladen",
  FileAction_Overwrite: "Wird überschrieben",
  FileCount_Tooltip: "Anzahl Dokumente",
  FileName: "Dateiname",
  FileSize: "Dateigrösse",
  Filter_Combobox_Filter_Customize: "Filter",
  Filter_Keywords_Description: "Durchsuche die Tabelle nach Stichworten",
  FilterToggle_ShowAgendaItems: "Zeige Traktanden",
  FilterToggle_ShowAgendaItems_Description: "Zeige Traktanden der aufgeklappten Gremien und Sitzungen an.",
  FilterToggle_ShowAgendaItems_Title: "Zeige Traktanden",
  FirstName: "Vorname",
  FolderName: "Ordner",
  Footer_Help: "Hilfe",
  Footer_HelpTitle: "SBB eDecide Hilfe",
  Footer_Imprint: "Impressum",
  Footer_Support: "Support",
  Footer_Title: "Impressum und Hilfe",
  GeneratedDocuments_Description: "Enthält die generierten Dokumente des Gremiums (Ausgabemenü)",
  GeneratedDocuments_Title: "Generierte Dokumente",
  GeneratorVariable_AgendaItem: "Traktandum",
  GeneratorVariable_NoAgendaItems: "Keine Traktanden gefunden",
  GeneratorVariable_Nr: "Nr.",
  GeneratorVariable_ParticipantWithRoleNotFound: "Es wurde kein Teilnehmer mit Rolle '{0}' gefunden!",
  GeneratorVariable_SeeConfidentialProtocol: "Siehe Protokoll (streng vertraulich)",
  GeneratorVariable_When: "Wann",
  GeneratorVariable_Who: "Wer",
  GridWorksConfig_Description: "Enthält die Konfiguration und Vorlagen des Gremiums",
  GridWorksConfig_Title: "Konfiguration",
  Group: "Gruppe",
  Group_Add: "Gruppe hinzufügen",
  Group_AddError: "Gruppe konnte nicht hinzugefügt werden",
  Group_AddSuccess: "Gruppe wurde erfolgreich hinzugefügt",
  Group_CleanupDeletedUsers: "Die Gruppe enthält {0} gelöschte Benutzer, bitte bereinige diese Einträge!",
  Group_ConfirmDelete: "Willst du die Gruppe wirklich entfernen?",
  Group_DeleteError: "Gruppe konnte nicht entfernt werden",
  Group_EntraIdName: "Entra Id Name",
  Group_EntraIdName_Description: "Wenn du hier eine Entra ID Gruppe (Omada) Gruppe verknüpfst, werden die Mitglieder periodisch importiert. Wenn keine Verknüpfung definiert ist, können die Mitglieder rechts gelöscht und hinzugefügt werden.",
  Group_Id: "Id",
  Group_MemberCount: "# Mitglieder",
  Group_Members: "Mitglieder",
  Group_Name: "Name",
  Group_Search: "Suche Gruppe …",
  Group_SearchStringHint: "Suche nach dem Namen der AD Gruppe.",
  Group_Titles: "AD Gruppen",
  GroupMember_ExistsInGroup: "Existiert in Gruppe",
  Groups: "Gruppen",
  Header_English: "English",
  Header_French: "Français",
  Header_German: "Deutsch",
  Header_Help: "Hilfe",
  Header_Italian: "Italiano",
  Header_SettingsMenu: "Einstellungen",
  Header_SettingsMenu_Cache: "Cache ansehen",
  Header_SettingsMenu_EditBoard: "Einstellungen bearbeiten",
  Header_SettingsMenu_ViewBoard: "Einstellungen ansehen",
  Header_UserMenu: "Aktueller Benutzer",
  Header_UserMenu_OneDrive: "OneDrive",
  Header_UserMenu_Profile: "Mein Konto",
  Header_UserMenu_SignOut: "Abmelden",
  Header_Version: "Version",
  Help: "Hilfe",
  HelpMenu_CosProductPage: "COS-Produkt eGPL 2",
  HelpMenu_Manuals: "Anleitungen",
  HelpMenu_Support: "Support",
  HelpMenu_VivaEngage: "Viva Engage Gruppe eGPL 2",
  History: "Verlauf",
  Home: "Home",
  Id: "Id",
  ImportedFromPhonebook: "Aus Telefonbuch importierte Felder",
  Info: "Zeige _START_ bis _END_ von _TOTAL_ Einträgen",
  InfoFiltered: "(gefiltert von _MAX_ Einträgen)",
  Initials: "Initialen",
  Initials_HelpText: `Wenn du das Feld leer lässt, wird der Standard angewendet.<br/>
Erster Buchstabe des Vornamens, erster Buchstabe des Nachnamens.`,
  Initials_Preview: "Vorschau",
  KendoReactGrid_CalendarToday: "Heute",
  KendoReactGrid_FilterAfterOperator: "Ist nach",
  KendoReactGrid_FilterAfterOrEqualOperator: "Ist nach oder gleich",
  KendoReactGrid_FilterBeforeOperator: "Ist vor",
  KendoReactGrid_FilterBeforeOrEqualOperator: "Ist vor oder gleich",
  KendoReactGrid_FilterBooleanAll: "(Alle)",
  KendoReactGrid_FilterContainsOperator: "Enthält",
  KendoReactGrid_FilterDoesNotContain: "Enthält nicht",
  KendoReactGrid_FilterEndWith: "Endet mit",
  KendoReactGrid_FilterEqOperator: "Entspricht",
  KendoReactGrid_FilterGteOperator: "Ist grösser oder gleich",
  KendoReactGrid_FilterGtOperator: "Ist grösser als",
  KendoReactGrid_FilterIsEmpty: "Ist leer",
  KendoReactGrid_FilterIsFalse: "Ist falsch",
  KendoReactGrid_FilterIsNotEmpty: "Ist nicht leer",
  KendoReactGrid_FilterIsNotEqualTo: "Ist nicht gleich",
  KendoReactGrid_FilterIsNotNull: "Ist nicht null",
  KendoReactGrid_FilterIsNull: "Ist null",
  KendoReactGrid_FilterIsTrue: "Is wahr",
  KendoReactGrid_FilterLteOperator: "Ist kleiner oder gleich",
  KendoReactGrid_FilterLtOperator: "Ist weniger als",
  KendoReactGrid_FilterStartsWith: "Beginnt mit",
  KendoReactGrid_NoRecords: "Keine Einträge verfügbar.",
  KendoReactGrid_PagerInfo: "{0} - {1} von {2} Einträgen",
  KeywordSearch: "Stichwortsuche",
  Language: "Sprache",
  LastModified: "Zuletzt geändert",
  LastModifiedBy: "Zuletzt geändert von",
  LastName: "Nachname",
  LastSync: "Letzte Synchronisation",
  Loading: "Lade …",
  Loading_MeetingTemplates: "Lade Standard-Sitzungen …",
  Logout: "Abmelden",
  LongName: "Langname",
  Meeting: "Sitzung",
  Meeting_AdditionalInfo_Description: "Text oder Link auf weitere Informationen",
  Meeting_AdditionalInfo_Title: "Weitere Informationen",
  Meeting_AgendaItems_Warning_Tooltip: "Die Traktandenliste der Standardsitzung wurde aktualisiert. Mit Traktandenliste aktualisieren kann der Standard auf diese Sitzung angewendet werden.",
  Meeting_Difference_Title: "Differenz",
  Meeting_DocumentStatus_ContextHelp_Title: "Arbeitsdokumente",
  Meeting_DocumentStatus_Description: "Zeigt die Anzahl Dokumente welche der Sitzung zugeordnet sind",
  Meeting_DocumentStatus_Title: "Arbeitsdokumente",
  Meeting_Duration_Title: "Zeitbedarf",
  Meeting_EdecideStatus_Description: "-",
  Meeting_EdecideStatus_RunManagementUrl: "Link 'Lauf bearbeiten' in eDecide",
  Meeting_EdecideStatus_RunUrl: "Link 'Lauf Details' in eDecide",
  Meeting_EdecideStatus_Status: "Status des Lauf in SiVe/eDecide",
  Meeting_EdecideStatus_Title: "eDecide Status",
  Meeting_EndDate_Description: "Bitte Enddatum und -zeit der Sitzung angeben. Die Endzeit entspricht einer Plangrösse. Diese wird mit der effektiven Endzeit verglichen. Bei Überschreitung der geplanten Zeit erscheint in der Auslastungsanzeige eine rote und bei Unterschreitung eine grüne Ampel.",
  Meeting_EndDate_Title: "Geplantes Ende",
  Meeting_EventDate: "Datum",
  Meeting_EventDate_Description: "Bitte Startdatum und -zeit der Sitzung angeben. Die Startzeiten der Traktanden berechnen sich anschliessend automatisch.",
  Meeting_EventDate_Title: "Datum",
  Meeting_EventTime_Title: "Geplante Startzeit",
  Meeting_IssueDate_Description: "In diesem Feld wird das Abgabedatum der Unterlagen für die Sitzung festgelegt.",
  Meeting_IssueDate_Title: "Ausgabedatum",
  Meeting_IsTemplate: "Ist Standard",
  Meeting_IsTemplate_Description: "Ändert die aktuelle Sitzung zu einer Standardsitzung um, so dass sie bei der Erstellung neuer Sitzungen als Vorlage verwendet werden kann. Wenn die aktuelle Sitzung eine Standardsitzung ist, kann sie wieder zu einer regulären Sitzung geändert werden.",
  Meeting_IsTemplate_Title: "Ist Standard",
  Meeting_Loading: "Lade Sitzung …",
  Meeting_Loading_EditForm: "Lade Sitzung Formular …",
  Meeting_Location_Description: "Bitte Sitzungsort und -zimmer angeben. Reihenfolge: Zimmerbezeichnung, Stockwerk, Strasse Nr., PLZ Ort",
  Meeting_Location_Title: "Ort/Sitzungszimmer",
  Meeting_Locked_Active_Tooltip: "Die Sitzung ist für Mitglieder zur Bearbeitung gesperrt.",
  Meeting_Locked_Description: "Bitte hier bei Bedarf die Sitzung sperren. Bei Gesperrt kann niemand mehr ein Traktandum erfassen. Eignet sich vor allem bei Reserve-Sitzungen oder bei der Geschäftsplanung und -steuerung.",
  Meeting_Locked_Inactive_Tooltip: "Die Sitzung ist für Mitglieder zur Bearbeitung freigegeben.",
  Meeting_Locked_Title: "Gesperrt",
  Meeting_New_Placeholder: "Neue Sitzung …",
  Meeting_Note_Description: "Bitte hier wichtige/übergeordnete Hinweise zur Sitzung ausweisen, zum Beispiel Sitzung findet extra muros statt.",
  Meeting_Note_Title: "Bemerkung",
  Meeting_PlannedEndTime_Title: "Geplante Endzeit",
  Meeting_ProjectedEndTime: "Effektive Endzeit",
  Meeting_ProjectedEndTime_Description: "-",
  Meeting_ProjectedEndTime_Title: "Effektive Endzeit",
  Meeting_Status_Description: "Bitte in diesem Feld den Status der Sitzung festhalten",
  Meeting_Status_Title: "Status",
  Meeting_SubmissionDate_Description: "Bitte hier das Abgabedatum der einzureichenden Unterlagen angeben.",
  Meeting_SubmissionDate_Title: "Abgabedatum",
  Meeting_TemplateId_Title: "Standard-Sitzung",
  Meeting_Title_Description: "Bitte folgendes Format verwenden: JJJJ-MM-TT_Kürzel Gremium-Sitzung (Beispiel: 2019-08-12_KL-Sitzung).",
  Meeting_Title_Title: "Titel",
  Meeting_UpdateParticipants_Warning_Tooltip: "Die Teilnehmer*innen der Standardsitzung wurden aktualisiert. Mit Teilnehmer*innen aktualisieren kann der Standard auf diese Sitzung angewendet werden.",
  Meeting_WorkingDocumentStatus_Title: "Arbeitsdokumente",
  Meeting_WorkingDocumentUrl_Description: "-",
  MeetingParticipants_Description: "Enthält die Teilnehmer*innen der Sitzungen",
  Meetings: "Sitzungen",
  Meetings_Description: "Enthält die Sitzungen",
  Meetings_EmptyTable: "Es wurden keine Sitzungen gefunden, die Deinen Kriterien entsprechen.",
  Meetings_Loading: "Lade Sitzungen …",
  Meetings_Title: "Sitzungen",
  MeetingStatus_Archived: "Archiviert",
  MeetingStatus_Complete: "Abgeschlossen",
  MeetingStatus_Default: "In Bearbeitung",
  MeetingStatus_Deleted: "Gelöscht",
  MeetingStatus_Published: "Publiziert",
  MeetingStatus_Unknown: "Unbekannt",
  Member: "Mitglied",
  Modified: "Geändert",
  ModifiedBy: "Geändert von",
  More: "Mehr",
  MoreEntries: "({0} Einträge)",
  MultiSelect_AllSelected: "Alle ausgewählt",
  MultiSelect_FilterPlaceholder: "Filtern …",
  MultiSelect_NoneSelected: "Keine Auswahl",
  MultiSelect_Reset: "Auswahl zurücksetzen",
  MultiSelect_SelectAll: "Alle auswählen",
  MultiSelect_Selected: "ausgewählt",
  MyRoles: "Meine Rollen",
  Name: "Name",
  Navigation_Administration: "Administration",
  No: "Nein",
  NoTitle: "Kein Titel",
  OneDrive_Sync_Mismatch: "Es liegen Dokumente bereit, die noch nicht zur Synchronisation publiziert wurden.",
  OneDriveDocument: "OneDrive Dokument",
  OneDriveSync_RemoteDocumentExistsUseOverwrite: "Die OneDrive-Datei existiert bereits für {0}, wähle im Aktions-Dropdown «Überschreiben» aus, um sie zu ersetzen.",
  OneDriveSync_RemoteFileNotUploaded: "Das Dokument {0} konnte nicht hochgeladen werden. Fehler: {1}",
  OneDriveSync_WorkingDocumentContentNotFound: "Arbeitsdokument {0} Inhalte konnten nicht geladen werden!",
  OneDriveSync_WorkingDocumentDoesNotExist: "Arbeitsdokument {0} existiert nicht!",
  OpenLinkNewWindow: "Link öffnen (in neuem Fenster)",
  OrganisationUnit: "Organisationseinheit",
  OriginalPath: "Anfrage Pfad",
  OutputDocument: "Ausgabedokument",
  OutputDocument_AgendaItemConfirmedMail_Description: "Erstellt eine Outlook Vorlage, mit welcher einer einreichenden Person mitgeteilt werden kann, dass ein eingereichtes Traktandum genehmigt wurde",
  OutputDocument_AgendaItemConfirmedMail_Title: "Traktandum bestätigen",
  OutputDocument_AgendaItemDeferredMail_Description: "Erstellt eine Outlook Vorlage, mit welcher einer einreichenden Person mitgeteilt werden kann, dass ein eingereichtes Traktandum verschoben wurde",
  OutputDocument_AgendaItemDeferredMail_Title: "Traktandum zurückstellen",
  OutputDocument_AgendaItemProtocolExtract_Description: "Erstellt den Protokoll-Auszug im Word Format",
  OutputDocument_AgendaItemProtocolExtract_Title: "Protokollauszug erstellen",
  OutputDocument_AgendaItemProtocolExtractMail_Description: "Erstellt eine Outlook Vorlage für das gewählte Traktandum, mit dem Protokoll-Auszug als PDF",
  OutputDocument_AgendaItemProtocolExtractMail_Title: "Protokollauszug versenden",
  OutputDocument_AgendaItemProtocolExtractPdf_Description: "Erstellt den Protokoll-Auszug im PDF Format",
  OutputDocument_AgendaItemProtocolExtractPdf_Title: "Protokollauszug erstellen",
  OutputDocument_ApplyStandardMeeting_Description: "Wähle eine Standard-Sitzung aus, und wende diese auf die bestehende Sitzung an.",
  OutputDocument_ApplyStandardMeeting_Title: "Standard-Sitzung anwenden",
  OutputDocument_Description: "Ausgabedokument Beschreibung",
  OutputDocument_Language: "Sprache",
  OutputDocument_Language_All: "Alle",
  OutputDocument_Language_None: "Keine",
  OutputDocument_MeetingAgendaItems_Description: "Erstellt eine Traktanden-Übersicht im Excel Format",
  OutputDocument_MeetingAgendaItems_Title: "Traktanden-Übersicht erstellen",
  OutputDocument_MeetingClone_Description: "-",
  OutputDocument_MeetingClone_Title: "Sitzung kopieren",
  OutputDocument_MeetingComplete_Description: "Schliesst die aktuelle Sitzung ab. Ab diesem Zeitpunkt sind Bearbeitungsmöglichkeiten eingeschränkt",
  OutputDocument_MeetingComplete_Title: "Sitzung schliessen",
  OutputDocument_MeetingEdecide_Description: "Startet einen Lauf in eDecide",
  OutputDocument_MeetingEdecide_Title: "eDecide Lauf erstellen",
  OutputDocument_MeetingFixate_Description: "Fixiert die aktuelle Sitzung. Ab diesem Zeitpunkt sind die Kapitel-Nummern für die Einladung fixiert",
  OutputDocument_MeetingFixate_Title: "Sitzung fixieren",
  OutputDocument_MeetingInvitation_Description: "-",
  OutputDocument_MeetingInvitation_Title: "Einladung erstellen",
  OutputDocument_MeetingInvitationMail_Description: "Erstellt die Einladung als Outlook Vorlage für den Versand an die Teilnehmer*innen",
  OutputDocument_MeetingInvitationMail_Title: "Einladung versenden",
  OutputDocument_MeetingOneNote_Description: "-",
  OutputDocument_MeetingOneNote_Title: "OneNote erstellen",
  OutputDocument_MeetingOverview_Description: "Erstellt die Traktandenliste zu Handen der Teilnehmer*innen (Einladung)",
  OutputDocument_MeetingOverview_Title: "Traktandenliste erstellen",
  OutputDocument_MeetingPresentationReminderMail_Description: "Erstellt eine Outlook Vorlage, mit der ein Reminder zur Einreichung der Präsentations-Unterlagen versendet werden kann",
  OutputDocument_MeetingPresentationReminderMail_Title: "Reminder Präsentationen versenden",
  OutputDocument_MeetingProtocolConfidential_Description: "Erstellt das Protokoll als Word Datei mit den streng vertraulichen Traktanden",
  OutputDocument_MeetingProtocolConfidential_Title: "Protokoll (streng vertraulich) erstellen",
  OutputDocument_MeetingProtocolMail_Description: "Erstellt das Protokoll als Outlook Vorlage",
  OutputDocument_MeetingProtocolMail_Title: "Protokoll versenden",
  OutputDocument_MeetingProtocolNonConfidential_Description: "Erstellt das Protokoll als Word Datei",
  OutputDocument_MeetingProtocolNonConfidential_Title: "Protokoll erstellen",
  OutputDocument_MeetingReminderMail_Description: "Erstellt eine Outlook Vorlage, mit der ein Reminder zur Einreichung der Unterlagen versendet werden kann",
  OutputDocument_MeetingReminderMail_Title: "Reminder versenden",
  OutputDocument_MeetingSaveAsDefault_Description: "Überschreibt die aktuelle Standardsitzung dieses Gremiums mit den in dieser Sitzung geltenden Traktanden und Teilnehmer*innen.",
  OutputDocument_MeetingSaveAsDefault_Title: "Als Standard speichern",
  OutputDocument_MeetingUpdateAgendaItems_Confirm: "Alle Traktanden, mit Ausnahme der manuell Hinzugefügten, werden gelöscht und die Traktandenliste der Standardsitzung wird angewendet.",
  OutputDocument_MeetingUpdateAgendaItems_Confirm_Title: "Traktandenliste aktualisieren?",
  OutputDocument_MeetingUpdateAgendaItems_Description: "Alle Traktanden, mit Ausnahme der manuell Hinzugefügten, werden gelöscht und die Traktandenliste der Standardsitzung wird angewendet.",
  OutputDocument_MeetingUpdateAgendaItems_Title: "Traktandenliste aktualisieren",
  OutputDocument_MeetingUpdateParticipants_Confirm: "Alle Teilnehmer*innen, mit Ausnahme der manuell Hinzugefügten, werden gelöscht und die Teilnehmer*innen Liste der Standardsitzung wird angewendet.",
  OutputDocument_MeetingUpdateParticipants_Confirm_Title: "Teilnehmer*innen aktualisieren?",
  OutputDocument_MeetingUpdateParticipants_Description: "Alle Teilnehmer*innen, mit Ausnahme der manuell Hinzugefügten, werden gelöscht und die Teilnehmer*innen der Standardsitzung wird angewendet.",
  OutputDocument_MeetingUpdateParticipants_Title: "Teilnehmer*innen aktualisieren",
  OutputDocument_Name: "Ausgabedokument",
  OutputDocument_Task_Description: "Pendenzen öffnen",
  OutputDocument_Task_Title: "Pendenzen öffnen",
  OutputDocument_WorkingDocumentsExportFolders_Description: "Erstellt ein Archiv mit allen Arbeitsdokumenten der aktuellen Sitzung",
  OutputDocument_WorkingDocumentsExportFolders_Title: "Arbeitsdokumente exportieren (zip)",
  OutputDocuments_Button_AgendaItem: "Aktuelles Traktandum",
  OutputDocuments_Button_Meeting: "Aktuelle Sitzung",
  OutputDocuments_Empty: "Es wurden keine Dokumente generiert.",
  OutputDocuments_FolderUrl: "Die folgenden Dokumente wurden erfolgreich erstellt",
  OutputDocuments_Header: "Dokumentengenerierung",
  OutputDocuments_Loading: "Erstelle Dokumente …",
  OutputDocuments_Success: "Erfolgreich gespeichert",
  OutputDocuments_Table_Name: "Dokument-Name",
  OutputDocuments_Table_Size: "Grösse",
  Owner: "Besitzer",
  Page_About_Title: "Über SiVe",
  Page_Admin_Title: "Administration",
  Page_Administration_Title: "Administration",
  Page_AgendaItem_Title: "Traktandum «{0}»",
  Page_AgendaItems_Title: "Traktanden",
  Page_Board_Title: "Gremium «{0}»",
  Page_BoardCache_Title: "Cache des Gremiums",
  Page_BoardEdit_Title: "Gremium «{0}» bearbeiten",
  Page_Boards_Title: "Gremien",
  Page_BoardSetup_Title: "Gremium Setup",
  Page_BoardTemplates_Title: "Gremium-Vorlagen",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "Claims",
  Page_Dashboard_Description: "Im Dashboard werden die kommenden Sitzungen aller Gremien angezeigt, in denen du berechtigt bist. Mit dem Datumsfilter kann der Anzeigezeitraum (Grundeinstellung: heute -14 Tage) geändert werden. Alle angezeigten Gremien und Sitzungen können per Klick aufgerufen werden.",
  Page_Dashboard_Title: "Dashboard",
  Page_Default_Title: "Übersicht",
  Page_DetailedDashboard_Title: "Übersicht Sitzungen & Traktanden",
  Page_Document_Title: "Dokument",
  Page_Documents_Title: "Dokumente",
  Page_Error_SubTitle: "Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten.",
  Page_Error_Title: "Fehler",
  Page_Group_Title: "Gruppe «{0}»",
  Page_Groups_Title: "Gruppen",
  Page_Impersonate_Title: "Identität annehmen",
  Page_JobStatus_Title: "Job Status",
  Page_Mails_Title: "Inxmail-Tests",
  Page_Meeting_Title: "Sitzung",
  Page_MeetingName_Title: "Sitzung «{0}»",
  Page_Meetings_Title: "Sitzungen",
  Page_Memory_Title: "Speicher",
  Page_OneDriveSync_Title: "OneDrive Synchronisation",
  Page_Participant_Title: "Teilnehmer*in «{0}»",
  Page_Participants_Title: "Teilnehmer*innen",
  Page_Resources_Title: "Übersetzungen",
  Page_SendTo_Title: "Senden an",
  Page_Settings_Title: "Einstellungen",
  Page_Setup_Title: "Setup",
  Page_SignOut_Title: "Abmelden",
  Page_StandardMeetingName_Title: "Standard-Sitzung «{0}»",
  Page_StaticCache_Title: "Statischer Cache",
  Page_Task_Title: "Pendenz «{0}»",
  Page_Tasks_Title: "Pendenzen",
  Page_Translations_Title: "Übersetzungen",
  Page_User_Title: "User «{0}»",
  Page_UserEdit_Title: "User «{0}» bearbeiten",
  Page_UserPreferences_Title: "Präferenzen",
  Page_Users_Title: "Users",
  Pagination_First: "Erste",
  Pagination_Last: "Letzte",
  Pagination_Next: "Nächste",
  Pagination_Previous: "Vorherige",
  Paging_First: "Erste",
  Paging_Items: "Elemente",
  Paging_Last: "Letzte",
  Paging_Next: "Nächste",
  Paging_Of: "von",
  Paging_OutOfBounds: "Die Parameter (skip*take) übersteigen die Anzahl verfügbare Ergebnisse.",
  Paging_Page: "Seite",
  Paging_Previous: "Vorherige",
  Paging_SkipTooLarge: "Die Parameter (skip*take) übersteigen die Anzahl verfügbare Ergebnisse.",
  Paging_TotalFiltered1: "1 Eintrag",
  Paging_TotalFilteredN: "{0} Einträge",
  Paging_TotalUnfiltered: "(gefiltert von {0} Einträgen)",
  PagingFirst: "Erste",
  PagingLast: "Letzte",
  PagingNext: "Nächste",
  PagingPrevious: "Vorherige",
  Participant: "Teilnehmer*In",
  Participant_Add_ContextHelp_Title: "-",
  Participant_Add_Description: "-",
  Participant_Add_Submitting: "Erstelle Teilnehmer*in …",
  Participant_Add_Success: "Teilnehmer*in wurde hinzugefügt",
  Participant_CanSeeConfidential_Description: "Wähle aus, ob der Teilnehmer vertrauliche Dokumente sehen kann",
  Participant_CanSeeConfidential_Title: "Streng vertrauliche Dokumente anzeigen",
  Participant_Loading: "Lade Teilnehmer*in …",
  Participant_Loading_EditForm: "Lade Teilnehmer*in Formular …",
  Participant_NavBar_AddParticipant: "Hinzufügen",
  Participant_NavBar_ToggleNav: "Navigation ein/ausblenden",
  Participant_Person_Title: "Person",
  Participant_Position_Description: "-",
  Participant_Position_Title: "Position",
  Participant_Remarks_Description: "Bemerkungen zur Teilnehmer*in",
  Participant_Remarks_Title: "Bemerkung",
  Participant_Remove_Success: "Teilnehmer*in wurde entfernt",
  Participant_Role_Description: "Bitte hier Vorsitz oder Protokoll wählen. Standardmässig wird die Rolle Mitglied hinterlegt.",
  Participant_Role_Title: "Rolle",
  Participant_Status_Description: "Bitte wähle den Status der Teilnehmer*in",
  Participant_Status_Title: "Status",
  Participant_User_Description: "Bitte wähle ein Mitglied des Gremiums",
  Participant_User_Title: "Person",
  ParticipantRole_Chair: "Vorsitz",
  ParticipantRole_NoDataTemplate: "Keine Rolle gefunden",
  ParticipantRole_Placeholder: "Wähle Rolle …",
  ParticipantRole_Protocol: "Protokoll",
  Participants: "Teilnehmer*innen",
  Participants_Description: "Enthält die Teilnehmer*innen der Sitzungen",
  Participants_Loading: "Lade Teilnehmer*innen …",
  Participants_NavBar_View: "Ansicht",
  Participants_Title: "Teilnehmer*innen",
  ParticipantsDetail_Empty: "Bitte wähle eine Teilnehmer*in  aus",
  ParticipantsList_Empty: "Es wurden keine Teilnehmer*innen erfasst",
  ParticipantStatus_Deleted: "Gelöscht",
  ParticipantStatus_Excused: "Entschuldigt",
  ParticipantStatus_Present: "Anwesend",
  ParticipantStatus_Unexcused: "Unentschuldigt",
  ParticipantStatus_Unknown: "Unbekannt",
  Permission_Add_Error: "Berechtigung konnte nicht hinzugefügt werden: {0}",
  Permission_Add_Success: "Berechtigung wurde hinzugefügt",
  Permission_Remove_Error: "Berechtigung konnte nicht entfernt werden: {0}",
  Permission_Remove_Success: "Berechtigung wurde entfernt",
  Permissions: "Berechtigungen",
  Personalisation: "Personalisierung",
  PersonalSiteUrl: "SharePoint MySite Url (OneDrive)",
  PersonnelNumber: "Personal-Nr.",
  Phone: "Telefon",
  Phonebook: "Telefonbuch",
  PhonebookLastSync: "Letzte Synchronisation",
  Placeholder: "Platzhalter",
  Properties: "Eigenschaften",
  PublishedDocuments: "Publizierte Dokumente",
  PublishedDocuments_Description: "Enthält die publizierten Dokumente des Gremiums.",
  PublishingDocuments_Tooltip: "-",
  ReadMore_Less: "Weniger anzeigen …",
  ReadMore_More: "Mehr anzeigen …",
  RequestId: "Anfrage ID",
  RichText_Link_Dialog_Title: "Link bearbeiten",
  RichText_Link_Invalid_URL: "Bitte gib eine gültige URL ein (https://, http://, mailto:)",
  RichText_Link_Remove: "Link entfernen",
  RichText_Link_Text_Label: "Anzeigetext",
  RichText_Link_URL_Label: "Ziel",
  RichText_Paste_Cancel_Tooltip: "Rückgängig machen (Einfügen abbrechen)",
  RichText_Paste_KeepFormatting_Tooltip: "Formatierung beibehalten",
  RichText_Paste_Options_Trigger_Tooltip: "Einfügeoptionen (Strg)",
  RichText_Paste_PlainText_Tooltip: "Nur Text einfügen",
  Richtext_Placeholder: "Text eingeben …",
  RichText_Tooltip_Background: "Hintergrundfrabe",
  RichText_Tooltip_Blockquote: "Als Blockzitat formattieren",
  RichText_Tooltip_Bold: "Fett (Ctrl+B)",
  RichText_Tooltip_Clean: "Formattierung löschen",
  RichText_Tooltip_Color: "Schriftfarbe",
  RichText_Tooltip_Heading: "Überschrift",
  RichText_Tooltip_Indent_Minus1: "Einzug verkleinern (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Einzug vergrössern (Tab)",
  RichText_Tooltip_Italic: "Kursiv (Ctrl+I)",
  RichText_Tooltip_Link: "Einen Link hinzufügen",
  RichText_Tooltip_List_Bullet: "Eine Aufzählung einfügen",
  RichText_Tooltip_List_Ordered: "Eine Nummerierte Liste einfügen",
  RichText_Tooltip_Script_Sub: "Tiefgestellt",
  RichText_Tooltip_Script_Super: "Hochgestellt",
  RichText_Tooltip_Size: "Schriftgrösse",
  RichText_Tooltip_Source: "HTML-Quelltext anzeigen",
  RichText_Tooltip_Strike: "Durchstreichen",
  RichText_Tooltip_Underline: "Unterstreichen (Ctrl+U)",
  Run: "Lauf",
  Runs: "Läufe",
  Save: "Speichern",
  SelectAll: "Alle auswählen",
  Selected_Actions: "Gewählte Aktionen",
  SendTo_Add_Error: "Verknüpfung konnte nicht hinzugefügt werden: {0}",
  SendTo_Add_Success: "Verknüpfung wurde hinzugefügt",
  SendTo_AddIncoming: "Quellgremium hinzufügen",
  SendTo_AddOutgoing: "Zielgremium hinzufügen",
  SendTo_Incoming: "Eingehende Verbindungen",
  SendTo_Outgoing: "Ausgehende Verbindungen",
  SendTo_Remove_Error: "Verknüpfung konnte nicht entfernt werden: {0}",
  SendTo_Remove_Success: "Verknüpfung wurde entfernt",
  SendtoPanel_Committee: "Gremium",
  SendtoPanel_Description: "Wähle eines oder mehrere Ziel-Gremien und deren Sitzungen aus, und führe die Aktion mit Senden aus.",
  SendtoPanel_Header: "Senden an",
  SendtoPanel_Loading: "Lade Gremien …",
  SendtoPanel_Meeting: "Sitzung",
  SendToPanel_Meeting_NoDataTemplate: "Keine Sitzungen gefunden",
  SendToPanel_Meeting_Placeholder: "Wähle Sitzung …",
  SendtoPanel_Submit: "Senden",
  SendtoPanel_Submitting: "Sende Traktanden an gewählte Gremien …",
  SendtoPanel_Success: "Die Traktanden wurden erfolgreich versandt.",
  SendtoPanel_Title: "Hilfe zu Senden an",
  SendToTargets: "Senden-an Zielgremien",
  ShortName: "Kurzname",
  ShowDeleted: "Zeige gelöschte Einträge",
  ShowInactive: "Zeige inaktive Einträge",
  ShowPermissions: "Zeige Berechtigungen",
  SignatureFirstName: "Vorname",
  SignatureFirstName_Undefined: "Die Einstellung 'Unterschrift Vorname' ist nicht definiert im Gremium!",
  SignatureLastName: "Nachname",
  SignatureLastName_Undefined: "Die Einstellung 'Unterschrift Nachname' ist nicht definiert im Gremium!",
  StandardAgendaItems: "Standard Traktanden",
  StandardMeeting_Apply_Error: "Standard-Sitzung konnte nicht angewendet werden: {0}",
  StandardMeeting_Apply_Success: "Standard-Sitzung wurde erfolgreich angewendet.",
  StandardMeeting_Empty: "Leer",
  StandardMeeting_Old: "Alte Vorlage (Wird bald gelöscht!)",
  StandardMeetingsPanel_Description: "Wähle eine Standard-Sitzung aus, und wende die Attribute der Sitzung, Traktanden und Teilnehmer*innen über die bestehende Sitzung an. Es werden nur die Sitzungen angeboten, deren Attribut \"Ist Standard\" aktiviert ist (Siehe Reiter \"Sitzung\").",
  StandardMeetingsPanel_Header: "Standard-Sitzung anwenden",
  StandardMeetingsPanel_Preview_Loading: "Lade Vorschau …",
  StandardMeetingsPanel_Submit: "Anwenden",
  StandardParticipants: "Standard Teilnehmer*innen",
  Statistics: "Statistiken",
  Statistics_Loading: "Lade Statistiken …",
  Status: "Status",
  StatusCode_401_SubTitle: "Du hast keinen Zugriff auf die Ressource.",
  StatusCode_401_Title: "Zugriff verweigert",
  StatusCode_403_SubTitle: "Du hast keine Berechtigungen für den Zugriff auf die Ressource.",
  StatusCode_403_Title: "Verboten",
  StatusCode_404_SubTitle: "Die Ressource wurde nicht gefunden.",
  StatusCode_404_Title: "Nicht gefunden",
  SuggestedAgendaItem_MeetingId_Title: "Sitzung",
  SuggestedAgendaItems: "Eingereichte Traktanden",
  SuggestedAgendaItems_Delete: "Löschen",
  SuggestedAgendaItems_Delete_Success: "Gewählte Elemente wurden gelöscht.",
  SuggestedAgendaItems_Deleting: "Gewählte Elemente werden gelöscht …",
  SuggestedAgendaItems_Description: "Enthält die eingereichten Traktanden des Gremiums",
  SuggestedAgendaItems_Filter: "Einschränken",
  SuggestedAgendaItems_Loading: "Lade eingereichte Traktanden …",
  SuggestedAgendaItems_Meeting: "Sitzung",
  SuggestedAgendaItems_Meeting_Tooltip: "Die vorgeschlagene Sitzung des eingereichten Traktandums. Dies ist ein informeller Hinweis der Person, welche das Traktandum eingereicht hat. Die gewählten Elemente werden immer zur aktuellen Sitzung hinzugefügt.",
  SuggestedAgendaItems_Move: "Hinzufügen",
  SuggestedAgendaItems_Move_Success: "Die gewählten Elemente wurden zur aktuellen Sitzung hinzugefügt.",
  SuggestedAgendaItems_Selection: "-",
  SuggestedAgendaItems_Selection_Tooltip: "Eingereichte Traktanden können hier gewählt werden. Auf den gewählten Elementen können im Anschluss die Aktionen Hinzufügen und Löschen angewendet werden.",
  SuggestedAgendaItems_Submitting: "Gewählte Elemente werden zur aktuellen Sitzung hinzugefügt …",
  SuggestedAgendaItems_Title: "Titel",
  SuggestedAgendaItems_Title_Tooltip: "Der Titel des eingereichten Traktandums",
  SuggestedAgendaItemsPanel_Header: "Eingereichte Traktanden",
  Table: "Tabelle",
  Table_NoRows: "Keine Datensätze gefunden.",
  Target: "Ziel",
  Task: "Pendenz",
  Task_AgendaItem_Description: "-",
  Task_AgendaItem_Title: "Traktandum",
  Task_AssignedTo_Description: "-",
  Task_AssignedTo_Title: "Zugewiesen an",
  Task_Description_Description: "-",
  Task_Description_Title: "Beschreibung",
  Task_DueDate_Description: "-",
  Task_DueDate_Title: "Fälligkeitsdatum",
  Task_Meeting_Description: "-",
  Task_Meeting_Title: "Sitzung",
  Task_NavBar_AddTask: "Hinzufügen",
  Task_NavBar_ToggleNav: "Navigation ein/ausblenden",
  Task_NotAssigned: "Nicht zugeordnet",
  Task_Source_Description: "-",
  Task_Source_Title: "Quelle",
  Task_StartDate_Description: "-",
  Task_StartDate_Title: "Startdatum",
  Task_Status_Description: "-",
  Task_Status_Title: "Status",
  Task_Title: "Titel",
  Task_Title_Title: "Titel",
  Task_Title_Tooltip: "Titel",
  Task_Validate_IsLonger_Title: "Das Feld Titel darf nicht länger als 255 Zeichen sein",
  TaskFilterToggle_Description: "Das Dashboard zeigt nur die Pendenzen an, die dem aktuellen Benutzer zugeordnet sind.",
  TaskFilterToggle_Title: "Nur meine Pendenzen",
  TaskGrid_ItemId: "ID",
  TaskGrid_ItemId_Tooltip: "Der ID der Pendenz",
  TaskList_Empty: "Es wurden keine Pendenzen erfasst",
  Tasks: "Pendenzen",
  Tasks_Add: "Pendenz hinzufügen",
  Tasks_Description: "Enthält die Pendenzen des Gremiums",
  Tasks_Loading: "Lade Pendenzen …",
  Tasks_Loading_EditForm: "Lade Pendenz Formular …",
  TasksDetail_Empty: "Bitte wähle eine Pendenz aus",
  TaskStatus_Archived: "Archiviert",
  TaskStatus_Complete: "Abgeschlossen",
  TaskStatus_Default: "In Bearbeitung",
  TaskStatus_Deferred: "Zurückgestellt",
  TaskStatus_InProgress: "In Bearbeitung",
  TaskStatus_NotStarted: "Nicht begonnen",
  TaskStatus_WaitingOnSomeoneElse: "Warten auf jemand anderen",
  TaskToggle_Description: "Zeigt die Pendenzen für alle Sitzungen an.",
  TaskToggle_Title: "Pendenzen anzeigen",
  Template_Remove_Error: "Vorlage konnte nicht entfernt werden: {0}",
  Template_Remove_Success: "Vorlage wurde erfolgreich gelöscht",
  Templates: "Vorlagen",
  Templates_ValidFileNames: "Gültige Dateinamen",
  TemplatesDescription: "Die Standard-Konfiguration der Applikation wird vom SiVe Entwicklungsteam mit der Applikation installiert. Korrekturen von Vorlagen werden so automatisch für alle Instanzen der Sitzungsverwaltung aktualisiert.",
  TenantName_Help: "Der Gremium Name wird in den Dokument-Vorlagen und im Benutzerinterface der Sitzungsverwaltung verwendet. Übliche Werte sind der volle Name des Gremiums wie Verwaltungsrat oder  Konzernleitung.",
  TimePicker_Hours: "Stunden",
  TimePicker_Minutes: "Minuten",
  Title: "Titel",
  Toast_Error: "Fehler",
  Toast_Success: "Erfolg",
  Toast_Warning: "Warnung",
  Total: "Gesamt",
  Upload_Choose: "Wähle Dateien …",
  Upload_ClearSelectedFiles: "Ausgewählte Dateien entfernen",
  Upload_DefaultDropZoneNote: "…",
  Upload_DropFilesHere: "Lege Dateien hier ab, um sie hochzuladen …",
  Upload_DropZoneHint: "Lege Dateien hier ab, um sie hochzuladen …",
  Upload_DropZoneNote: "Nur {0} Dateien sind erlaubt.",
  Upload_Files: "Dateien",
  Upload_HeaderStatusUploaded: "Erledigt",
  Upload_HeaderStatusUploading: "Hochladen…",
  Upload_InvalidFileExtension: "Dateityp nicht erlaubt.",
  Upload_InvalidFiles: "Ungültige Dateien. Bitte überprüfe die Anforderungen für den Datei-Upload.",
  Upload_InvalidMaxFileSize: "Dateigrösse zu gross",
  Upload_InvalidMinFileSize: "Dateigrösse zu klein",
  Upload_SelectNoFilesTitle: "Drücken, um weitere Dateien auszuwählen",
  Upload_SelectTitle: "Dateien auswählen…",
  Upload_StatusFailed: "Die Dateien konnten nicht hochgeladen werden.",
  Upload_StatusUploaded: "Die Dateien wurden erfolgreich hochgeladen.",
  Upload_StatusUploadFailed: "Dateien konnten nicht hochgeladen werden.",
  Upload_StatusUploading: "Wird hochgeladen …",
  Upload_StatusWarning: "Warnung",
  Upload_Total: "Total",
  Upload_UploadSelectedFiles: "Gewählte Dateien hochladen",
  UploadFile: "Datei",
  Upn: "Prinzipalname",
  User: "User",
  User_AnonymizedDisplayName: "Gelöschter Benutzer",
  User_Boards: "Gremien",
  User_DisplayName: "Name",
  User_Email: "Email",
  User_Email_Description: "Bitte hier die E-Mail-Adresse angeben.",
  User_Email_Title: "Email",
  User_FirstName: "Vorname",
  User_FirstName_Description: "Bitte Vorname angeben.",
  User_FirstName_Title: "Vorname",
  User_Initials: "Initialen",
  User_Initials_Description: "Bitte hier das Kürzel der Person angeben",
  User_Initials_HelpText: `Wenn du das Feld leer lässt, wird der Standard angewendet.<br/>
Erster Buchstabe des Vornamens, erster Buchstabe des Nachnamens.`,
  User_Initials_Preview: "Vorschau",
  User_Initials_Title: "Initialen",
  User_Language: "Sprache",
  User_LastName: "Nachname",
  User_LastName_Description: "Bitte Nachname angeben.",
  User_LastName_Title: "Nachname",
  User_LastSync: "Letzte Synchronisation",
  User_OrganisationUnit: "Organisationseinheit",
  User_PersonalSiteUrl: "SharePoint MySite Url (OneDrive)",
  User_PersonnelNumber: "Personal-Nr.",
  User_Phone: "Telefon",
  User_Status: "Status",
  User_Sync_Error: "User*in konnte nicht synchronisiert werden: {0}",
  User_Sync_NotSupported: "Synchronisierung für diese User*in ist nicht unterstützt",
  User_Sync_Success: "User*in wurde synchronisiert",
  User_Unknown: "Unbekannt",
  User_Update_Error: "User konnte nicht gespeichert werden: {0}",
  User_Update_Success: "User wurde gespeichert",
  User_Upn: "Prinzipalname",
  User_UserRoles: "Rollen",
  UserMenu_MyDetails: "Mein Profil",
  UserMenu_SignOut: "Abmelden",
  UserPicker: "User nachschlagen",
  UserPicker_NoDataTemplate: "Keine Teilnehmer*innen gefunden",
  UserPicker_Placeholder: "Bezeichner eingeben …",
  UserPreferences_Description: "Konfiguriere hier Deine Präferenzen für die Darstellung der Sitzungsverwaltung. Wenn Deine Berechtigungen zum Beispiel die Anzeige von gelöschten Elementen nicht umfasst, hat die entsprechende Einstellung keinen Einfluss.",
  UserRole_Administrator: "Administrator",
  UserRole_Application: "Applikation",
  UserRole_BoardOwner: "Gremiumsbesitzer",
  UserRole_Unknown: "Unbekannt",
  UserRole_User: "User",
  UserRoles: "Rollen",
  Users: "Nutzende",
  UserSettings: "Einstellungen",
  UserStatus_Deleted: "Gelöscht",
  UserStatus_Enabled: "Aktiv",
  UserStatus_Unknown: "Unbekannt",
  Validation_Board_CannotArchiveWithActiveMeetings: "Das Gremium kann nicht archiviert werden, da noch aktive Sitzungen vorhanden sind.",
  Validation_Board_NameAlreadyUsed: "Es existiert bereits ein Gremium mit diesem Wert ({0}, {1})",
  Validation_Date_MustBeEarlierThan: "Der Wert des Felds '{0}' muss früher als der Wert des Felds '{1}' sein.",
  Validation_Date_YearAtLeast: "'{0}' (Jahr) muss grösser oder gleich {1} sein.",
  Validation_Document_ContentBytesEmpty: "Die hochgeladene Datei '{0}' hat eine ungültige Länge von 0 Bytes.",
  Validation_Document_FileNameEmpty: "Die hochgeladene Datei hat keinen Dateinamen.",
  Validation_Document_IsProtected: "Die hochgeladene Datei '{0}' wurde als verschlüsselt erkannt, Grund: {1}.",
  Validation_Field_ConcurrentDashes: "'{0}' darf nicht mehrere Bindestriche nacheinander enthalten.",
  Validation_Field_EndsWithDashes: "'{0}' darf nicht mit Bindestrichen enden.",
  Validation_Field_InvalidCharacters: "'{0}' enthält ungültige Zeichen ('{1}', Position: {2}).",
  Validation_Field_LeadingOrTrailingWhitespace: "'{0}' darf keine Leerzeichen am Anfang oder Schluss enthalten.",
  Validation_Field_MustBeGreaterThanZero: "'{0}' muss einen Wert grösser als 0 haben, ist {1}.",
  Validation_Field_MustBeSameAs: "'{0}' ({1}) muss denselben Wert enthalten wie '{2}' ({3}).",
  Validation_Field_MustNotBeEmpty: "'{0}' darf nicht leer sein.",
  Validation_Field_NotInValidNames: "'{0}' enthält keinen der gültigen Namen.",
  Validation_Field_StartsWithDashes: "'{0}' darf nicht mit Bindestrichen beginnen.",
  Validation_Participant_AlreadyExists: "Es existiert bereits ein Teilnehmer '{0}' in dieser Sitzung.",
  ValidationFailures: "Validierungs-Fehler",
  View_AgendaItems_Details: "Details",
  View_AgendaItems_Overview: "Übersicht",
  View_AgendaItems_Protocol: "Protokoll",
  View_Documents_Grid: "Übersicht",
  View_OneDriveSync_Overview: "OneDrive Sync",
  View_Participants_Details: "Details",
  View_Participants_Overview: "Übersicht",
  View_Tasks_Overview: "Übersicht",
  View_Views_Edit: "Bearbeiten",
  Visitor: "Besucher",
  WorkingDocument: "Arbeitsdokument",
  WorkingDocument_FileExtension: "Datei-Endung",
  WorkingDocument_FileName: "Dateiname",
  WorkingDocument_FileSize: "Grösse",
  WorkingDocument_StorageUrl: "Blob Url",
  WorkingDocument_UniqueId: "Eindeutige Id",
  WorkingDocuments: "Arbeitsdokumente",
  WorkingDocuments_Add_Button: "Dokument hochladen",
  WorkingDocuments_Description: "Enthält die Arbeitsdokumente des Gremiums",
  WorkingDocuments_Tooltip: "Den dazugehörigen Ordner in den Dokumenten öffnen.",
  Yes: "Ja",
};
